<template>
    <div @click="react"
         data-locator="reaction"
         class="reaction"
         :class="{ 'reaction--active' : hasReacted }"
         v-tooltip="reactionMessage"
    >
        <emoji data-locator="emoji" :size="16" :emoji="emoji" class="reaction__emoji"></emoji>
        <span data-locator="count" class="reaction__count">{{ reactions.length }}</span>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Emoji } from 'emoji-mart-vue'

export default {
    props: {
        reactions: {
            type: Array,
            required: true
        },
        emoji: {
            type: String,
            required: true
        },
        commentId: {
            type: Number,
            required: true
        }
    },

    methods: {
        react () {
            // TODO: Close nav

            this.hasReacted
                ? this.$store.dispatch('job/removeReaction', this.findUserReaction)
                : this.$store.dispatch('job/addReaction', {
                    commentId: this.commentId,
                    type: this.emoji
                })
        }
    },

    computed: {
        ...mapState('users', {
            current: 'current'
        }),

        findUserReaction () {
            return this.reactions.find(reaction => reaction.user_id === this.current.id && reaction.type === this.emoji)
        },

        hasReacted () {
            return this.findUserReaction !== undefined
        },

        reactionMessage () {
            let text = ''
            let names = this.reactions.map((reaction) => this.current.id === reaction.user_id ? 'You' : reaction.user.display_name)

            return names.length === 1
                ? `${names[0]} reacted with ${this.emoji}`
                : names.slice(0, names.length - 1).join(', ') + ` and ${names[names.length - 1]} reacted with ${this.emoji}`
        }
    },

    components: {
        Emoji
    }
}
</script>